/*
 * Dubai time (UTC+4, no daylight saving) for every real instant the pages show - whatever the browser's own zone
 * (a laptop abroad, a VPN, a wrong OS setting). Owner's rule: all times are Dubai time. One place, so the pages never
 * mix 12-hour and 24-hour texts (review 18 Oct 2026).
 */
const DUBAI_MS = 4 * 60 * 60 * 1000;
export const DAY_MS = 24 * 60 * 60 * 1000;
const pad = (n) => String(n).padStart(2, '0');

// the instant as a Date whose UTC fields read Dubai's wall clock (null when it is no time)
const wall = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const t = value instanceof Date ? value.getTime()
        : typeof value?.toDate === 'function' ? value.toDate().getTime()   // a Firestore Timestamp
            : new Date(value).getTime();
    return Number.isNaN(t) ? null : new Date(t + DUBAI_MS);
};

/** "dd/mm/yyyy" in Dubai ('' when it is no time). */
export const dubaiDate = (value) => {
    const d = wall(value);
    return d ? `${pad(d.getUTCDate())}/${pad(d.getUTCMonth() + 1)}/${d.getUTCFullYear()}` : '';
};

/** "HH:MM" (24-hour) in Dubai, with ":SS" when asked. */
export const dubaiTime = (value, { seconds = false } = {}) => {
    const d = wall(value);
    if (!d) return '';
    return `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}${seconds ? `:${pad(d.getUTCSeconds())}` : ''}`;
};

/** "dd/mm/yyyy HH:MM" in Dubai. */
export const dubaiDateTime = (value, opts) => {
    const day = dubaiDate(value);
    return day ? `${day} ${dubaiTime(value, opts)}` : '';
};

/** "yyyy-mm-dd" - the Dubai calendar day of the instant (today when no value is given). */
export const dubaiIsoDay = (value = new Date()) => {
    const d = wall(value);
    return d ? d.toISOString().slice(0, 10) : '';
};

/** Dubai's hour now (0-23) - for "Good morning" greetings. */
export const dubaiHour = (now = new Date()) => wall(now).getUTCHours();

/** Dubai midnight of a "yyyy-mm-dd" day as a ms instant (null when it is no day). */
export const dubaiDayStartMs = (yyyyMmDd) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(yyyyMmDd || '').trim());
    return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) - DUBAI_MS : null;
};

/** "Sunday, 18 October 2026" for Dubai's day. */
export const dubaiLongDate = (now = new Date()) => new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Dubai', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
}).format(now);
